<template>
  <v-dialog
    v-model="show"
    width="400px">
    <div class="dialog-container">
      <div class="dialog-header">
        <p>{{title}}</p>
        <font-awesome-icon
          icon="times"
          class="pointer"
          @click="changeDialog"></font-awesome-icon>
      </div>
      <div class="dialog-body">
        <el-form
          ref="form"
          :model="form"
          :rules="rules">
          <div class="form-item">
            <span>Partner Name</span>
            <el-form-item prop="partner_nm">
              <v-input
                v-model="form.partner_nm"
                :reg="/[^A-Za-z0-9-_]/g"
                maxlength="32"></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Logo (300x90px)</span>
            <el-form-item prop="file_url">
              <v-upload
                :fileData="{
                  thumb_url: form.file_url
                }"
                card
                notUpload
                width-full
                :promise="beforUpload"
                @uploadForm="handlerUploadSuccess"></v-upload>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Coupon Code / Referral Code</span>
            <el-form-item prop="coupon_code">
              <!-- <v-select
                v-model="form.coupon_code"
                placeholder="Coupon Title - COUPONCODE"
                noList
                remote
                :remoteMethod="remoteMethod"
                :list="useCouponList"
                :labelKey="'title'"
                :labelSecondKey="'coupon_code'"
                :valueKey="'coupon_code'"
                @focus="handleFocus"></v-select> -->
              <v-input
                v-model="form.coupon_code"
                uppercase></v-input>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Code Save</span>
            <v-radio-group
              v-model="form.code_save"
              border
              :list="yesNoOptions"></v-radio-group>
          </div>
          <div class="form-item">
            <span>Product</span>
            <el-form-item prop="class_id">
              <v-select
                v-model="form.class_id"
                :list="productList"></v-select>
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Promotion Period</span>
            <el-form-item prop="date">
              <v-date-picker
                v-model="form.date"
                type="daterange"></v-date-picker>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <div class="btn">
          <div class="lef">
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
          </div>
          <div class="right">
            <v-button
              v-if="isEdit"
              gray
              class="red"
              @click="handleDisable">Disable</v-button>
            <v-button
              green
              @click="handleSave">Save</v-button>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import {campaignCreateLink, campaginDelLink} from '@/api/micropolicy'
import { getUseCouponList } from '@/api/coupon'
import MixinOptions from '@/mixins/options'

export default {
  name: 'PartnerLinkDialog',
  mixins: [MixinOptions],
  props:{
    rowData: {
      type: Object,
      default: () => {}
    },
    isEdit:{
      type: Boolean,
      default: false
    }
  },
  data () {
    const checkImg = (rule, value, cb) => {
      if(!value){
        cb(new Error(this.$t('placeholder.upload')))
      }
      cb()
    }
    return {
      show: false,
      form:{
        partner_nm: '',
        file: null,
        class_id: '',
        cmnt_dt: '',
        expry_dt: '',
        coupon_code: '',
        id: '',
        date: [],
        file_url: '',
        code_save: 0
      },
      rules:{
        partner_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        file_url: [
          {validator: checkImg}
        ],
        class_id: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
        date: [
          { required: true, message: this.$t('placeholder.select'), trigger: ['change', 'blur'] }
        ],
      },
      useCouponList: [],
      timer: null,
    }
  },
  computed:{
    title(){
      return this.isEdit? 'Edit Link' : 'Create New Link'
    },
    productList(){
      let data = []
      data = this.globalOptions.campaigns_class_data
      return data
    }
  },
  watch:{
    'form.date':{
      immediate: true,
      deep: true,
      handler(val){
        if(val.length){
          this.form.cmnt_dt = val[0]
          this.form.expry_dt = val[1]
        }
      }
    },
    'form.cmnt_dt':{
      immediate: true,
      handler(val){
        if(val && this.form.expry_dt){
          this.form.date = []
          this.form.date.push(val)
          this.form.date.push(this.form.expry_dt)
        }
      }
    },
    rowData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val){
          Object.keys(val).forEach(key => {
            this.form[key] = val[key]
          })
        }
      }
    },
    isEdit:{
      immediate: true,
      handler(val){
        if(val){
          if(this.rowData){
            Object.keys(this.rowData).forEach(key => {
              this.form[key] = this.rowData[key]
            })
          }
        }
      }
    },
    'form.file_url':{
      immediate: true,
      handler(val){
        if(val){
          if(this.$refs['form']){
            // 当url有值则清空上传框的校验
            this.$refs['form'].clearValidate(['file_url'])
          }
        }
      }
    }
  },
  methods: {
    changeDialog(){
      this.show = !this.show
    },

    handlerUploadSuccess(res){
      const {file, result} = res
      this.$set(this.form, 'file', file)
      this.$set(this.form, 'file_url', result.url)
    },

    beforUpload(file){
      // 判断文件类型
      return new Promise(async(res, rej) => {
        let fileType = file.type
        if(fileType != 'image/png'){
          this.$message({
            type: 'warning',
            message: '只能上傳PNG格式的文件'
          })
          rej(false)
          return
        }
        // 判断文件大小
        let fileSize = file.size / 1024
        if(fileSize > 300){
          this.$message({
            type: 'warning',
            message: '文件大小不能超過300KB'
          })
          rej(false)
          return
        }
        // 判断图片尺寸
        let img = new Image()
        img.src = URL.createObjectURL(file)
        let pro = new Promise(resolve => {
          img.onload = () => {
            let width = img.width
            let height = img.height
            if(width != 300 && height != 90){
              this.$message({
                type: 'warning',
                message: '圖片尺寸只能300x90px'
              })
              rej(false)
              return
            }
            resolve()
          }
        })
        await pro
        res(file)
      })
    },

    handleCancel(){
      this.changeDialog()
    },
    handleDisable(){
      let params = {
        link_id: this.rowData.id
      }
      this.network().campaginDelLink(params)
    },
    handleSave(){
      this.$refs['form'].validate(valid => {
        if(valid){
          let params = new FormData()
          let keys = ['partner_nm','file','class_id','cmnt_dt','expry_dt','coupon_code','code_save']
          keys.forEach(key => {
            if(this.form[key] || this.form[key] == 0){
              params.append(key, this.form[key])
            }
          })
          if(this.isEdit){
            params.append('link_id', this.form.id)
          }
          this.network().campaignCreateLink(params)
        }
      })
    },

    remoteMethod(query){
      let params = {
        search_text: query,
        hideLoading: true
      }
      if(this.timer){
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.network().getUseCouponList(params)
      }, 500)
    },

    handleFocus(){
      this.useCouponList = []
    },

    resetForm(){
      if(this.$refs['form']){
        this.$refs['form'].resetFields()
        Object.keys(this.form).forEach(key => {
          if(key == 'date'){
            this.form[key] = []
          }else if(key == 'code_save'){
            this.form[key] = 0
          }else{
            this.form[key] = ''
          }
        })
      }
    },

    network(){
      return {
        getUseCouponList: async (params) => {
          let {data} = await getUseCouponList(params)
          this.useCouponList =data
        },

        campaignCreateLink: async(params) => {
          const {data} = await campaignCreateLink(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.changeDialog()
            this.$emit('success')
          }
        },

        campaginDelLink: async params => {
          const {data} = await campaginDelLink(params)
          if(data.code == 1000){
            this.$message({
              type: 'success',
              message: data.message_language
            })
            this.changeDialog()
            this.$emit('success')
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.dialog-container{
  .dialog-header{
    height: 20px;
    padding: 16px;
    box-sizing: content-box;
    display: flex;
    justify-content: space-between;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #1B1F23;
  }
  .dialog-body{
    padding: 20px 15px 0 15px;
    .el-form{
      .form-item:last-child{
        padding-bottom: 0;
      }
    }
  }
  .dialog-footer{
    padding: 20px 15px 15px 15px;
    .btn{
      display: flex;
      justify-content: space-between;
      .red{
        color: #CB2431;
      }
    }
  }
}
</style>
